import React from "react";
import {cn} from "./cn";

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
    padding?: "none" | "sm" | "md" | "lg";
    interactive?: boolean;
}

const paddings: Record<NonNullable<CardProps["padding"]>, string> = {
    none: "",
    sm: "p-4",
    md: "p-6",
    lg: "p-7",
};

export const Card: React.FC<CardProps> = ({padding = "md", interactive, className, children, ...props}) => (
    <div
        className={cn(
            "bg-surface border border-border rounded-2xl shadow-card",
            interactive && "transition-colors duration-150 hover:border-border-strong hover:bg-surface-hover cursor-pointer",
            paddings[padding],
            className
        )}
        {...props}
    >
        {children}
    </div>
);
